<template>
  <div class="push-record-list">
    <!-- 状态切换与查询共用工具栏，为消息列表保留展示空间。 -->
    <div class="message-toolbar">
      <a-radio-group
        class="read-state-filter"
        :value="queryParam.readState || ''"
        aria-label="阅读状态"
        @change="changeReadState">
        <a-radio-button value="">全部</a-radio-button>
        <a-radio-button value="UNREAD">
          未读 <a-icon v-if="unreadCountLoading" type="loading" />
          <span v-else-if="unreadCount !== null" class="unread-count">{{ unreadCount }}</span>
        </a-radio-button>
        <a-radio-button value="READ">已读</a-radio-button>
      </a-radio-group>
      <a-form class="message-search" layout="inline" @submit.prevent="searchQuery">
        <a-form-item label="消息类别">
          <a-input v-model="queryParam.title" class="title-filter" placeholder="请输入消息类别" allowClear />
        </a-form-item>
        <a-form-item label="推送时间">
          <a-date-picker v-model="dates.createTime" @change="onDateSdata" />
        </a-form-item>
        <div class="search-actions">
          <a-button type="primary" htmlType="submit" icon="search">查询</a-button>
          <a-button @click="searchReset()" icon="reload">重置</a-button>
        </div>
      </a-form>
      <a-button class="read-all-button" :loading="markingAllRead" :disabled="loading" @click="readAll" icon="check">全部标为已读</a-button>
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowClassName="messageRowClass"
        :scroll="{ x: 1080 }"
        :locale="{ emptyText: listError || (queryParam.readState === 'UNREAD' ? '暂无符合条件的未读消息' : '暂无符合条件的消息') }"
        @change="handleTableChange">
        <span slot="messageTitle" slot-scope="text, record" class="message-title" :class="{ 'message-title-unread': !record.readAt }">
          <span v-if="!record.readAt" class="unread-dot" aria-hidden="true"></span>
          {{ text }}
        </span>
        <span slot="readState" slot-scope="text, record" class="read-state" :class="record.readAt ? 'read-state-read' : 'read-state-unread'">
          {{ record.readAt ? '已读' : '未读' }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a href="#" @click.prevent="handleDetails(record)">查看</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->


    <push-message-detail ref="messageDetail" @business="handleBusiness" @read="handleMessageRead" @close="handleDetailClose" />
  </div>
</template>

<script>

import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, putAction } from '@/api/manage'

import PushMessageDetail from './modules/PushMessageDetail'
export default {
  name: 'PushRecordList',
  mixins: [JeecgListMixin],
  components: { PushMessageDetail,
  },
  data() {
    return {
      index: 200,
      pagePath: '/sys/push/messages/mine',
      pageTitle: '消息推送记录',
      loginUserName: '',
      // 阅读筛选切换后，仅接受最新列表请求的结果。
      listRequestId: 0,
      unreadCount: null,
      unreadCountLoading: false,
      markingAllRead: false,
      refreshAfterDetail: false,
      listError: '',
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          dataIndex: 'title',
          colName: 'title',
          title: '消息类别',
          align: 'left',
          scopedSlots: { customRender: 'messageTitle' }

        },
        {
          dataIndex: 'content',
          colName: 'content',
          title: '消息详细',
          align: 'left'

        },
        {
          dataIndex: 'isRead_dictText',
          colName: 'is_read',
          title: '阅读状态',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'readState' }
        },
        {
          dataIndex: 'createTime',
          title: '推送时间',
          width: 190,
          align: 'center'

        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 90,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {

        readAllMsg: '/sys/push/messages/mine/read-all'
      }
    }
  },
  created() {
  },
  mounted() {
    this.hidePageSelectors()
    if (this.$route.query.businessId) getAction('/sys/push/messages/mine/' + this.$route.query.businessId).then(res => { if(res.success)this.handleBusiness(res.result.message) })
  },
  activated() { this.hidePageSelectors() },
  computed: {},
  methods: {

    /** 从任意入口或缓存页恢复消息列表时，隐藏与本人消息无关的选择区。 */
    hidePageSelectors() {
      this.$bus.$emit('showSite', 'show', false)
      this.$bus.$emit('showProject', 'show', false)
    },

    /**
     * 时间筛选
     * @param value
     * @param createTime
     */
    onDateSdata: function(value, createTime) {
      this.queryParam.start = createTime ? createTime + ' 00:00:00' : undefined
      this.queryParam.end = createTime ? createTime + ' 23:59:59' : undefined
    },

    changeReadState(event) {
      this.$set(this.queryParam, 'readState', event.target.value)
      this.loadData(1)
    },

    messageRowClass(record) {
      return record.readAt ? 'message-row-read' : 'message-row-unread'
    },

    /** 阅读期间保留列表位置，关闭详情后再同步已读状态和数量。 */
    handleMessageRead() {
      if (this.$refs.messageDetail.visible) this.refreshAfterDetail = true
      else this.loadData()
    },
    handleDetailClose() {
      if (!this.refreshAfterDetail) return
      this.refreshAfterDetail = false
      this.loadData()
    },

    handleDetails(data) { this.$refs.messageDetail.open(data.id) },
    handleBusiness(data) {
      if (data.title == '待审批流程') {
        getAction('/wf/flow/work/todo-list', {
          processInstanceId: data.viewFrom
        }).then(data1 => {
          if (data1.success) {
            if (!data1.result || data1.result.records.length < 1) {
              this.$message_ele.warning('该流程已被流程管理员删除')
            } else {
              this.$router.push({
                path: '/workflow/list/list',
                query: {
                  processInstanceId: data1.result.records[0].processInstanceId,
                  workTabName: '1',
                  workTabKey: data1.result.records[0].processDefinitionKey,
                  detailTab: 1,
                  index: this.index++
                }
              })
            }
          } else {
            this.$message_ele.warning('该流程已被流程管理员删除')
          }
        })
      } else if (data.title == '审批抄送') {
        getAction(
          '/wf/flow/work/cc-list', {
            processInstanceId: data.viewFrom
          }
        ).then((data1) => {
          if (data1.success) {
            if (!data1.result || data1.result.records.length < 1) {
              this.$message_ele.warning('该流程已被流程管理员删除')
            } else {
              this.$router.push({
                path: '/workflow/list/list',
                query: {
                  processInstanceId: data1.result.records[0].processInstanceId,
                  workTabName: '0',
                  workTabKey: data1.result.records[0].processDefinitionKey,
                  detailTab: 0,
                  index: this.index++
                }
              })
            }

          } else {
            this.$message_ele.warning('该流程已被流程管理员删除')
          }
        })
      } else if (data.title == '审批评论') {
        getAction(
          '/wf/flow/follow/list', {
            processInstanceId: data.viewFrom
          }
        ).then((data1) => {
          if (data1.success) {
            if (!data1.result || data1.result.records.length < 1) {
              this.$message_ele.warning('该流程已被流程管理员删除')
            } else {
              this.$router.push({
                path: '/workflow/list/list',
                query: {
                  processInstanceId: data1.result.records[0].processInstanceId,
                  workTabName: '0',
                  workTabKey: data1.result.records[0].processDefinitionKey,
                  detailTab: 0,
                  index: this.index++
                }
              })
            }

          } else {
            this.$message_ele.warning('该流程已被流程管理员删除')
          }
        })
      } else if (data.title == '审批催读') {
        getAction(
          '/wf/flow/follow/list', {
            processInstanceId: data.viewFrom
          }
        ).then((data1) => {
          if (data1.success) {
            if (!data1.result || data1.result.records.length < 1) {
              this.$message_ele.warning('该流程已被流程管理员删除')
            } else {
              this.$router.push({
                path: '/workflow/list/list',
                query: {
                  processInstanceId: data1.result.records[0].processInstanceId,
                  workTabName: '0',
                  workTabKey: data1.result.records[0].processDefinitionKey,
                  detailTab: 0,
                  index: this.index++
                }
              })
              putAction('/sys/push/messages/mine/' + data.id + '/read').then(() => {

              })
              // fetch.request(changeFlowCc + '/' + data.viewFrom,
              // 	"POST", '', true);
            }

          } else {
            this.$message_ele.warning('该流程已被流程管理员删除')
          }
        })
      } else if (data.title == '流程终止') {
        getAction(
          '/wf/flow/follow/list', {
            processInstanceId: data.viewFrom
          }
        ).then((data1) => {
          if (data1.success) {
            if (!data1.result || data1.result.records.length < 1) {
              this.$message_ele.warning('该流程已被流程管理员删除')
            } else {
              this.$router.push({
                path: '/workflow/list/list',
                query: {
                  processInstanceId: data1.result.records[0].processInstanceId,
                  workTabName: '0',
                  workTabKey: data1.result.records[0].processDefinitionKey,
                  detailTab: 0,
                  index: this.index++
                }
              })
            }

          } else {
            this.$message_ele.warning('该流程已被流程管理员删除')
          }
        })
      } else {
        this.$message_ele.warning(data.content)
      }
    },
    loadData(arg) {
      return this.initTableData(arg)
    },
    /** 将明确的阅读状态转换为统一查询参数，并丢弃过期响应。 */
    initTableData(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() //查询条件
      params.current = this.ipagination.current
      params.size = this.ipagination.pageSize
      // 阅读状态不再依赖旧字典的数字含义，false也必须传给后端。
      delete params.readState
      if (this.queryParam.readState === 'UNREAD') params.unread = true
      else if (this.queryParam.readState === 'READ') params.unread = false
      else delete params.unread
      const requestId = ++this.listRequestId
      const url = this.url && this.url.list ? this.url.list : this.pagePath
      this.loading = true
      this.listError = ''
      this.unreadCount = null
      this.unreadCountLoading = true
      const countRequest = params.unread === true ? Promise.resolve() : this.loadUnreadCount(url, params, requestId)
      const listRequest = getAction(url, params).then(res => {
        if (requestId !== this.listRequestId) return
        if (res.success) {
          // 最后一条未读被移除后，回到仍有数据的页码。
          const lastPage = Math.max(1, Math.ceil(res.result.total / this.ipagination.pageSize))
          if (this.ipagination.current > lastPage) {
            this.ipagination.current = lastPage
            return this.initTableData()
          }
          this.dataSource = res.result.records.map(record => ({...record, isRead: record.readAt ? '2' : '1', isRead_dictText: record.readAt ? '已读' : '未读'}))
          this.ipagination.total = res.result.total
          if (params.unread === true) this.unreadCount = res.result.total
        } else {
          throw new Error(res.message || '消息加载失败，请重试')
        }
      }).catch(() => {
        if (requestId !== this.listRequestId) return
        this.dataSource = []
        this.ipagination.total = 0
        this.listError = '消息加载失败，请点击查询重试'
        this.$message_custom(this.listError, 'warning')
      }).finally(() => {
        if (requestId === this.listRequestId) {
          this.loading = false
          if (params.unread === true) this.unreadCountLoading = false
        }
      })
      return Promise.all([listRequest, countRequest])
    },

    /** 使用服务端总数统计当前类别、日期下的全部未读，不受分页影响。 */
    loadUnreadCount(url, params, requestId) {
      return getAction(url, { ...params, unread: true, current: 1, size: 1, searchCount: true }).then(res => {
        if (requestId === this.listRequestId && res.success) this.unreadCount = res.result.total
      }).catch(() => {
        if (requestId === this.listRequestId) this.unreadCount = null
      }).finally(() => {
        if (requestId === this.listRequestId) this.unreadCountLoading = false
      })
    },

    readAll() {
      if (this.markingAllRead) return
      this.$confirm({
        title: '确认操作',
        content: '将我的全部未读消息标为已读，包含当前筛选条件之外的消息。是否继续？',
        onOk: () => {
          this.markingAllRead = true
          return putAction(this.url.readAllMsg).then(res => {
            if (!res.success) throw new Error(res.message || '标记失败，请重试')
            this.$message_custom('全部消息已标为已读')
            return this.loadData(1)
          }).catch(error => {
            this.$message_custom(error.message || '标记失败，请重试', 'warning')
          }).finally(() => {
            this.markingAllRead = false
          })
        }
      })
    }

  }
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';

.push-record-list {
  padding: 0 16px 12px;
  border: 1px solid #e8edf3;
  border-radius: 8px;
  background: #fff;
  color: #4b5563;
  .read-all-button { color: #596579; border-color: #dce2ea; box-shadow: none; }
  .message-search { display: flex; align-items: center; flex-wrap: wrap; gap: 8px 16px; margin-left: auto; }
  .message-search /deep/ .ant-form-item { display: flex; align-items: center; margin: 0; }
  .message-search /deep/ .ant-form-item-label > label { color: #596579 !important; }
  .message-search /deep/ .ant-form-item-control-wrapper { min-width: 0; }
  .message-search .title-filter { width: 220px; }
  .message-search /deep/ .ant-calendar-picker { width: 180px; }
  .message-search /deep/ .ant-form-item-control > span { color: #4b5563 !important; }
  .search-actions { display: flex; align-items: center; gap: 8px; }
  .message-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 20px;
    min-height: 64px;
    padding: 8px 0;
    border-bottom: 1px solid #e8edf3;
  }
  .read-state-filter { display: flex; flex-shrink: 0; gap: 16px; }
  .read-state-filter /deep/ .ant-radio-button-wrapper {
    height: 40px;
    min-width: 64px;
    padding: 0 8px;
    border: 0;
    border-bottom: 3px solid transparent;
    border-radius: 0;
    background: transparent;
    color: #697586;
    line-height: 37px;
    text-align: center;
    box-shadow: none;
  }
  .read-state-filter /deep/ .ant-radio-button-wrapper::before { display: none; }
  .read-state-filter /deep/ .ant-radio-button-wrapper-checked {
    border-bottom-color: #1677ff;
    color: #0958d9;
    font-weight: 600;
    box-shadow: none !important;
  }
  .read-state-filter /deep/ .ant-radio-button-wrapper:hover { color: #0958d9; }
  .read-state-filter /deep/ .ant-radio-button-wrapper:focus-within {
    outline: 2px solid #69c0ff;
    outline-offset: 2px;
  }
  .unread-count { display: inline-block; min-width: 20px; margin-left: 4px; padding: 0 6px; border-radius: 10px; background: #eef2f7; color: #5c6b7e; font-size: 12px; font-weight: 500; line-height: 20px; }
  /deep/ .ant-radio-button-wrapper-checked .unread-count { color: #0958d9; background: #e6f4ff; }
  .message-title { color: #606266; }
  .message-title-unread { color: #1f2937; font-weight: 600; }
  .unread-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    margin-right: 8px;
    border-radius: 50%;
    background: #1677ff;
    vertical-align: middle;
  }
  .read-state { display: inline-block; line-height: 22px; }
  .read-state-unread {
    padding: 0 9px;
    border-radius: 4px;
    background: #e6f4ff;
    color: #0958d9;
    font-weight: 600;
  }
  .read-state-read { color: #7b8493; }
  /deep/ .ant-table { color: #596579; }
  /deep/ .ant-table-thead > tr > th { padding: 14px 16px; background: #f7f9fc; color: #667085; font-size: 13px; font-weight: 500; border-bottom-color: #e8edf3; }
  /deep/ .ant-table-tbody > tr > td { padding: 16px; border-bottom-color: #edf0f4; }
  /deep/ .ant-table-tbody > tr.message-row-unread > td { background: #f5f9ff; }
  /deep/ .ant-table-tbody > tr.message-row-unread > td:first-child { box-shadow: inset 3px 0 #1677ff; }
  /deep/ .ant-table-tbody > tr.message-row-read:hover > td,
  /deep/ .ant-table-tbody > tr.message-row-read.ant-table-row-hover > td { background: #f7f9fc; }
  /deep/ .ant-table-tbody > tr.message-row-unread:hover > td,
  /deep/ .ant-table-tbody > tr.message-row-unread.ant-table-row-hover > td { background: #e6f4ff; }
  // 当前面板为浅色，分页需覆盖外层深色主题的白色文字。
  /deep/ .ant-pagination { color: #596579 !important; }
  /deep/ .ant-pagination-item a, /deep/ .ant-pagination-item-link { color: #596579 !important; }
  /deep/ .ant-pagination-item, /deep/ .ant-pagination-item-link { background: #fff !important; }
  /deep/ .ant-pagination-item-active { background: #e6f4ff !important; border-color: #1677ff; }
  /deep/ .ant-pagination-item-active a { color: #0958d9 !important; }
  /deep/ .ant-pagination-disabled .ant-pagination-item-link { color: #b8c1cd !important; }
  /deep/ .ant-pagination-options-quick-jumper { color: #596579 !important; }
  /deep/ .ant-pagination-options-quick-jumper input { color: #4b5563; }
}
@media (max-width: 1399px) {
  .push-record-list {
    .message-toolbar { column-gap: 12px; }
    .message-search { column-gap: 12px; }
    .message-search .title-filter { width: 180px; }
    .message-search /deep/ .ant-calendar-picker { width: 160px; }
  }
}
@media (max-width: 1199px) {
  .push-record-list {
    .message-toolbar { justify-content: space-between; }
    .message-search { order: 3; width: 100%; margin-left: 0; }
  }
}
@media (max-width: 575px) {
  .push-record-list {
    padding: 0 12px 12px;
    .read-state-filter { gap: 4px; }
    .read-state-filter /deep/ .ant-radio-button-wrapper { min-width: 52px; padding: 0 4px; }
    .message-search /deep/ .ant-form-item { width: 100%; }
    .message-search /deep/ .ant-form-item-control-wrapper { flex: 1; }
    .message-search .title-filter, .message-search /deep/ .ant-calendar-picker { width: 100%; }
  }
}
</style>
